const AssignmentTypes = {
  All: -1,
  Assignment: 0,
  Session: 1,
  PublicAssignment: 2,
  Assessment: 3,
  Benchmark: 4
};
      
export default AssignmentTypes;